'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _has = require('has');

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// I18nHtmlSafe is a utility component made to safely inject HTML from I18n.t preventing the need
// for dangerouslySetInnerHTML. This removes the need to convert string to HTML which can prevent
// XSS attacks if a translator includes JS code or an engineer forgets to sanitize a field key.
//
// Basic usage:
// const icon = <i className="icon icon-danger" />;
// <I18nHtmlSafe
//   text={'if you see this %{icon} then stop'}
//   values={{ icon: icon }}
// />
//
// Usage with open and closing tags
// const link = <a href="/" />;
// <I18nHtmlSafe
//   text={'Click %{link_start}here%{link_end} to continue'}
//   values={{ link: link }}
// />
//

var FragmentOrSpan = typeof _react2['default'].Fragment === 'undefined' ? 'span' : _react2['default'].Fragment;

var propTypes = {
  text: _propTypes2['default'].string.isRequired,
  elementType: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].oneOf([FragmentOrSpan])]),
  values: _propTypes2['default'].object
};

var defaultProps = {
  elementType: FragmentOrSpan,
  values: {}
};

/* eslint no-use-before-define: 1 */

var START_SUFFIX = '_start';
var END_SUFFIX = '_end';
var ALLOW_HTML_SUFFIX = '_dangerous_html';

function hasSuffix(keyName, suffix) {
  // returns true if this key ends with START_SUFFIX;
  return keyName.slice(-suffix.length) === suffix;
}

// given the input:
// text: 'example_start}inside%{example_end} OR example}outside'
// it will give the output of seek and child. undefined if invalid
function parseChild(text, values) {
  // get the key name
  var keyEndPos = text.indexOf('}');
  if (keyEndPos === -1) {
    // catch error if none exists which means they forgot to close it.
    console.error('Missing closing } for I18n phrase ' + String(text));
    return undefined;
  }

  // keyName could be 'example' or 'example_start'
  var keyName = text.slice(0, keyEndPos);
  var seek = 0;
  var child = null;
  var html = false;

  // now we check the type of keyName this is. If it ends with START_SUFFIX then special case here.
  if (hasSuffix(keyName, START_SUFFIX)) {
    // we need to get the child content, stuff inside %{keyName_start} and %{keyName_end}
    var afterStart = text.slice(keyEndPos + 1);
    // keyName would be example_start, where coreKeyName is just example
    var coreKeyName = keyName.slice(0, keyName.length - START_SUFFIX.length);
    var endPos = afterStart.indexOf('%{' + String(coreKeyName) + END_SUFFIX + '}');
    if (endPos === -1) {
      // TODO(lmr): when we have `invariant()` and `if (__DEV__)`, we should use that instead.
      console.error('Missing closing token for ' + String(keyName));
      return undefined;
    }

    var element = values[coreKeyName];
    // seek past the end of everything
    seek = keyEndPos + endPos + coreKeyName.length + END_SUFFIX.length + '%{}'.length + 1;
    if (!element) {
      // fallback to %{example_start}inside%{example_end}
      child = '%{' + String(text.slice(0, seek));
    } else {
      child = _react2['default'].cloneElement(element, {}, parseChildren(afterStart.slice(0, endPos), values));
    }
  } else if ((0, _has2['default'])(values, keyName + ALLOW_HTML_SUFFIX)) {
    // in this case, we have a `%{foo}` in the string, and a `foo_dangerous_html` string provided,
    // in which case we DANGEROUSLY ALLOW the html to get rendered.
    child = values[keyName + ALLOW_HTML_SUFFIX];
    seek = keyEndPos + 1;
    html = true;
  } else {
    // this is the basic usage case
    child = values[keyName] != null ? values[keyName] : '%{' + String(keyName) + '}';
    seek = keyEndPos + 1;
  }

  return {
    child: child,
    seek: seek,
    keyName: keyName,
    html: html
  };
}

function parseChildren(text, values) {
  var children = [];
  var index = 0;
  var parsedText = text;
  while (parsedText.indexOf('%{') !== -1) {
    // put all the stuff before into children
    var pos = parsedText.indexOf('%{');
    if (pos > 0) {
      children.push(parsedText.slice(0, pos));
    }

    // get the stuff after %{
    var rest = parsedText.slice(pos + 2);
    var result = parseChild(rest, values);
    if (!result) {
      break;
    }

    if (result.html) {
      children.push(_react2['default'].createElement('span', { key: index, dangerouslySetInnerHTML: { __html: result.child } }));
    } else {
      // add this child to the list of results
      children.push(_react2['default'].createElement(
        FragmentOrSpan,
        { key: index },
        result.child
      ));
    }

    // now seek past the end of this key and continue
    parsedText = rest.slice(result.seek);
    index += 1;
  }

  // if there is remaining text like 'click %{here} stuff', we need to add ' stuff'
  if (parsedText) {
    children.push(parsedText);
  }
  return children;
}

var I18nHtmlSafe = function (_React$Component) {
  _inherits(I18nHtmlSafe, _React$Component);

  function I18nHtmlSafe() {
    _classCallCheck(this, I18nHtmlSafe);

    return _possibleConstructorReturn(this, (I18nHtmlSafe.__proto__ || Object.getPrototypeOf(I18nHtmlSafe)).apply(this, arguments));
  }

  _createClass(I18nHtmlSafe, [{
    key: 'componentDidCatch',

    // eslint-disable-next-line class-methods-use-this
    value: function () {
      function componentDidCatch(error, info) {
        // React 16.3+ fails to reconcile text content modified outside of the component lifecycle.
        // Unfortunately, this is an unavoidable error in cases where users use browser extensions to
        // translate text. We can either wrap each node in a <span> element or silence the errors.
        // Because introducing more DOM nodes drastically reduces render performance, we choose to
        // ignore the errors.
        // eslint-disable-next-line no-console
        console.error(error, info);
      }

      return componentDidCatch;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            Type = _props.elementType,
            text = _props.text,
            values = _props.values;

        return _react2['default'].createElement(
          Type,
          null,
          parseChildren(text, values)
        );
      }

      return render;
    }()
  }]);

  return I18nHtmlSafe;
}(_react2['default'].Component);

exports['default'] = I18nHtmlSafe;


I18nHtmlSafe.propTypes = propTypes;
I18nHtmlSafe.defaultProps = defaultProps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-i18n/T/I18nHtmlSafe.js
// module id = 452
// module chunks = 168707334958949